module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "preface02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('strong', [_vm._v("An Explanation of Plant Headings")])])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Generic entries are provided with a pronunciation guide, common name and family. Each specific epithet (the species term) has a pronunciation guide, common name, and average height and width of mature plants. The height and width are guides to help with placement in the garden. Climate, soils, rainfall, irrigation practices and fertility will influence these guidelines. The next line provides season of flowering (based on zone 5-7), flower color, origin and cold hardiness range, based on the USDA zone hardiness map.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0xix-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("A quick reference table is provided for genera with two or more cultivated species. Easily identifiable differences among species are listed. Descriptions for each species and known cultivars and varieties are also included. Not every cultivar or variety has found its way into the book, but ideally most of available selections are present. Related species and hybrids are then described briefly. In general, related species are not always as available to the gardening public but have worthy garden characteristics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Descriptions such as flower color and height are based on my experience and travels and they will differ slightly from North to South and East to West. All the bad jokes and opinions are mine, made proudly and without shame. But, regardless of how opined I may be, they are still only opinions. I welcome yours.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40270294","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface02.vue
// module id = 63
// module chunks = 0